import axios from 'axios';
import storage from 'local-storage-fallback';
import { Auth } from 'aws-amplify';
import { runLogoutHandler } from './authBridge';

export const handleError = error => {

};

const _connect = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  headers: {
    //'Content-Type': 'application/json;charset=UTF-8',//'text/plain',//
    //'Access-Control-Allow-Origin': '*',
  },
});

_connect.interceptors.request.use(
  async (config) => {
    await getToken(config);
    return config;

  },
  (error) => {
    console.error("error", error);
    return Promise.reject(error);
  },
);

_connect.interceptors.response.use(
  (res) => {

    if(res.data.status !== 1){
      return Promise.reject("error");
    }
    return res;
  },
  async (error) => {
    
    const originalConfig = error.config;
    if (error.response) {
      if (error.response.status === 401) {
        return Promise.reject(error.response.data);
      }

      if (error.response.status !== 401) {
        return Promise.reject(error.response.data);
      }
    }
    
    return Promise.reject(error);

  }

);

const getToken = async (config) => {
  //
  
  const expirationDate = isJwtExpiringIn10Minutes();

  if(expirationDate){
    //refresh
    if(storage.getItem('protagonistas_rtoken')){
      const refreshToken_ = await refreshToken();
    }
    
  }

  config.headers.Authorization = storage.getItem('protagonistas_token');
  /*
  await Auth.currentSession().then(res=>{
    const idToken = res.getIdToken();
    config.headers.Authorization = idToken.jwtToken;//temp_token;
  })
  */
}

const refreshToken = async () => {
    axios.post(process.env.REACT_APP_BASE_URL+'/refresh_token', {refreshToken: storage.getItem('protagonistas_rtoken')}, {
      headers: {}
    })
    .then(response => {
      
      if('RefreshToken' in response.data){
        storage.setItem('protagonistas_rtoken', response.data.RefreshToken);
      }
      storage.setItem('protagonistas_token', response.data.idToken);
      //get_terms_and_conditions(response.data)
    })
    .catch(async (error) => {
      await runLogoutHandler();
      //console.log("🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎🥎");
      //console.error(error);
    });
  };

const isJwtExpiringIn10Minutes = () => {
  let token = storage.getItem('protagonistas_token');
  
  if (!token) return false;
  const payload = token.split('.')[1];
  if (!payload) return false;
  const decoded = JSON.parse(atob(payload));
  if (!decoded.exp) return false;
  const expiration = decoded.exp * 1000;
  const now = Date.now();
  // 10 minutos en milisegundos = 600000
  //console.log("expiration", expiration-now);
  //console.log("token", "("+expiration +"-"+ now+")" +" <= 600000", (expiration - now) <= 600000);
  return (expiration - now) <= 600000;
}

export default _connect;
//28337219


